
export default {
	computed: {
		placeholder() {
			if (this.$isBlueBranding) {
				return "EDIT YOUR SEARCH";
			}
			return (
				((this.$store.getters["navigation/isUnscramblerResultsPage"] ||
					this.$store.getters[
						"navigation/isScrabbleDictionaryResultsPage"
					] ||
					this.$store.getters["navigation/isAnagramResultsPage"] ||
					this.$store.getters[
						"navigation/isNYTCrossplayDictionaryResultsPage"
					]) &&
					this.$route.params?.tiles) ||
				"ENTER LETTERS"
			);
		},
		tilesFontsize() {
			const smallerLettersThreshold = 15;
			const queryLength = this.placeholder.length;
			const fontSize = queryLength >= smallerLettersThreshold ? 22 : 25;
			if (queryLength >= smallerLettersThreshold) {
				return `${
					fontSize - (queryLength - smallerLettersThreshold)
				}px`;
			}
			return null;
		},
	},
	methods: {
		onClick() {
			this.$emit("click");
		},
	},
};
